<template>
  <div id="introduction" class="container">
    <div class="section columns is-gapless is-mobile is-centered is-multiline">
      <figure class="section--image column is-12-mobile is-6-tablet">
        <img src="/static/img/intro-img.jpg" alt="Introduction">
      </figure>

      <div class="section--main--holder column is-12-mobile is-6-tablet">
        <section class="section--main">
          <h2 class="section--title">
            <img src="/static/img/titles/Introduction.png" alt="Introduction">
            <strong class="seo">Introduction</strong>
          </h2>

          <agile v-if="introData" :options="sliderOption">
            <div v-for="page in introData" :key="page.id" class="page">
              <p class="page--content" v-html="page.content_sections_item"></p>
            </div>
          </agile>

          <!-- <carousel v-if="introData" :per-page="1" :navigationEnabled="false" :paginationEnabled="true">
            <slide v-for="page in introData" v-bind:key="page.id" class="page">
              <p class="page--content" v-html="page.content_sections_item"></p>
            </slide>
          </carousel> -->
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from '@/services/axios.js'
// import VueCarousel from 'vue-carousel'
import VueAgile from 'vue-agile'

Vue.use(VueAgile)
// Vue.use(VueCarousel)

export default {
  name: 'introduction',
  data () {
    return {
      introData: null,
      sliderOption: {
        perPage: 1,
        autoplay: false,
        dots: true,
        arrows: false,
        infinite: false,
        speed: 800,
        fade: false,
        timing: 'ease-in-out'
      }
    }
  },

  created () {
    this.fetchData()
  },

  methods: {
    fetchData () {
      axios.get('wp-json/wp/v2/pages?slug=introduction')
        .then(response => {
          this.introData = response.data[0].acf.content_sections
        })
        .catch(e => { console.log(e) })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Introduction.vue